import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const checkHaveNotification = async (user_id, account_id, location_id) => {
  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/notifications/has_unread_notification?account_id=${account_id}&location_id=${location_id}&user_id=${user_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getAllNotifications = async (filter) => {
  const { account_id, location_id, user_id, page } = filter;

  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/notifications/all?account_id=${account_id}&location_id=${location_id}&user_id=${user_id}&page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const getShortNotifications = async (filter) => {
  const { account_id, location_id, user_id, page } = filter;

  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/notifications/fetch_from_redis?account_id=${account_id}&location_id=${location_id}&user_id=${user_id}&page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const markAsRead = async (data) => {
  try {
    const response = await axios.post(
      `${Config.notificationServerUrl}/notifications/mark-all-as-read`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};